import { Select } from "@mantine/core";
import { useSelector } from "react-redux";
import {
  selectedCountrySelector,
  setSelectedCountry,
} from "../../../store/slices/verificationSlice";
import { useDispatch } from "react-redux";

interface IRenderCountrySelect {
  countries: string[];
}
const RenderCountrySelect = (props: IRenderCountrySelect) => {
  const { countries } = props;
  const selectedCountry = useSelector(selectedCountrySelector);
  const dispatch = useDispatch();
  return (
    <div className="country-selection-container">
      <Select
        w="50%"
        searchable
        clearable
        label=""
        value={selectedCountry}
        onChange={(value) => dispatch(setSelectedCountry(value))}
        placeholder="Select country"
        data={countries}
      />
    </div>
  );
};

export default RenderCountrySelect;
